import { forwardRef } from 'react';
import type { SelectHTMLAttributes } from 'react';
import { cn } from '../../lib/cn';
import { FIELD_CLASS } from './input';

/**
 * Select na natywnym `<select>`. Swiadomie bez popovera: natywna kontrolka jest
 * w pelni obslugiwana z klawiatury i przez czytniki ekranu w kazdej
 * przegladarce, a M2 nie potrzebuje nic wiecej.
 */
export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  function Select({ className, children, ...props }, ref) {
    return (
      <select ref={ref} className={cn(FIELD_CLASS, 'pr-8', className)} {...props}>
        {children}
      </select>
    );
  },
);

export type EnumSelectProps<T extends string> = {
  readonly value: T;
  readonly options: readonly T[];
  readonly onChange: (value: T) => void;
  readonly id?: string;
  readonly disabled?: boolean;
  /** Etykieta czytelna dla czlowieka; brak = surowa wartosc enumu. */
  readonly labelOf?: (value: T) => string;
  readonly className?: string;
};

/** Select nad lista `as const` z `shared` — zero zdublowanych slownikow w UI. */
export function EnumSelect<T extends string>({
  value,
  options,
  onChange,
  id,
  disabled,
  labelOf,
  className,
}: EnumSelectProps<T>) {
  return (
    <Select
      {...(id === undefined ? {} : { id })}
      value={value}
      disabled={disabled}
      className={className}
      onChange={(event) => {
        const next = event.currentTarget.value;
        // Wartosci pochodza z `options`, wiec zawezenie jest bezpieczne.
        const match = options.find((option) => option === next);
        if (match !== undefined) onChange(match);
      }}
    >
      {options.map((option) => (
        <option key={option} value={option}>
          {labelOf === undefined ? humanize(option) : labelOf(option)}
        </option>
      ))}
    </Select>
  );
}

/** `three_quarter_high` -> `three quarter high`. */
export function humanize(token: string): string {
  return token.replace(/_/g, ' ');
}
